import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import './assets/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import App from './App.vue'
import store from '../store'
import TestuserBuilder from './components/TestuserBuilder.vue'
Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)



const routes = [
	{ path: '/', component: TestuserBuilder},
	// { path: '/', component: HelloWorld}
]

const router = new VueRouter({
	routes,
	mode: 'history'
})
document.title = "IAM TestUser Builder"
new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
